import { Stack, Typography } from "@mui/material";
import React from "react";

const DisWindow = () => {
  return (
    <Stack spacing={2} width="100%">
      <Typography fontSize={20} textAlign="center">
        Discretionary Window Notice
      </Typography>
    </Stack>
  );
};

export default DisWindow;
